module.exports = ".modal-dialog {\n  width: 70%;\n  max-width: none;\n  overflow-y: auto; }\n\n.table-div {\n  max-height: 600px;\n  overflow-y: auto; }\n\n.request-date {\n  width: 20%; }\n\n.return-date {\n  width: 20%; }\n\n.position {\n  width: 60%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-property-search/bc-property-search.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-property-search/bc-property-search.component.scss
// module chunks = main